import * as React from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentStep } from "../Installer/Stepper/stepperSlice";
import { useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";

export default function CancelJobButton({ onCancel }) {
  const currentStep = useSelector(getCurrentStep);
  const navigate = useNavigate();

  const handleClick = () => {
    if (onCancel) {
      onCancel();
    } else if (currentStep === 0) {
      navigate(-1);
    } else {
      // Pause — job stays saved, installer can resume from the dashboard
      navigate("/installer/");
    }
  };

  return (
    <ClearIcon
      sx={{ mt: 1, cursor: "pointer" }}
      onClick={handleClick}
    />
  );
}
